import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.scss';

const InputText = props => {
  const { onChange } = props;
  const handleChange = useCallback(
    e => {
      onChange(e.target.value);
    },
    [onChange],
  );

  return (
    <input
      className={`${styles.textInput} ${props.className}`}
      type='text'
      defaultValue={props.value}
      onChange={handleChange}
      disabled={props.disabled}
    />
  );
};

export default InputText;

InputText.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

InputText.defaultProps = {
  onChange: () => null,
  className: '',
  disabled: false,
};
